export const NPS_QUESTION_TEXT_PREFIX = 'How likely are you to recommend '

export const NPS_QUESTION_TEXT_SUFFIX =
  ' to a friend or colleague? 0 (not likely) - 10 (very likely)'

export const NPS_QUESTION_COMPANY_PLACEHOLDER = 'company or product name'

export const getNpsQuestionText = (companyName: string) =>
  `${NPS_QUESTION_TEXT_PREFIX}${companyName}${NPS_QUESTION_TEXT_SUFFIX}`
